    import { useState } from "react";
    import { useNavigate, useParams } from "react-router-dom";

    const ZodiacWheel = () => {
        const navigate = useNavigate();
        const { signo } = useParams();
        const [hoveredIndex, setHoveredIndex] = useState(null);

        const signos = [
            { name: "Aries", link: "/horoscopo/aries", img: "/images/aries.png", dates: "21 Mar - 19 Abr", element: "Fuego" },
            { name: "Tauro", link: "/horoscopo/taurus", img: "/images/taurus.svg", dates: "20 Abr - 20 May", element: "Tierra" },
            { name: "Géminis", link: "/horoscopo/gemini", img: "/images/gemini.svg", dates: "21 May - 20 Jun", element: "Aire" },
            { name: "Cáncer", link: "/horoscopo/cancer", img: "/images/cancer.png", dates: "21 Jun - 22 Jul", element: "Agua" },
            { name: "Leo", link: "/horoscopo/leo", img: "/images/leo.svg", dates: "23 Jul - 22 Ago", element: "Fuego" },
            { name: "Virgo", link: "/horoscopo/virgo", img: "/images/virgo.svg", dates: "23 Ago - 22 Sep", element: "Tierra" },
            { name: "Libra", link: "/horoscopo/libra", img: "/images/libra.svg", dates: "23 Sep - 22 Oct", element: "Aire" },
            { name: "Escorpio", link: "/horoscopo/scorpio", img: "/images/scorpio.svg", dates: "23 Oct - 21 Nov", element: "Agua" },
            { name: "Sagitario", link: "/horoscopo/sagittarius", img: "/images/sagittarius.svg", dates: "22 Nov - 21 Dic", element: "Fuego" },
            { name: "Capricornio", link: "/horoscopo/capricorn", img: "/images/capricorn.png", dates: "22 Dic - 19 Ene", element: "Tierra" },
            { name: "Acuario", link: "/horoscopo/aquarius", img: "/images/aquarius.png", dates: "20 Ene - 18 Feb", element: "Aire" },
            { name: "Piscis", link: "/horoscopo/pisces", img: "/images/pisces.svg", dates: "19 Feb - 20 Mar", element: "Agua" },
        ];

        const centerX = 200;
        const centerY = 200;
        const radius = 150;
        const angleStep = (2 * Math.PI) / signos.length;

        return (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <svg width="600" height="600" viewBox="0 0 400 400" style={{ display: "block" }}>
                    {signos.map((signoObj, index) => {
                        const angle = index * angleStep - Math.PI / 2;
                        const x = centerX + radius * Math.cos(angle);
                        const y = centerY + radius * Math.sin(angle);

                        return (
                            <g
                                key={index}
                                onMouseEnter={() => setHoveredIndex(index)}
                                onMouseLeave={() => setHoveredIndex(null)}
                                onClick={(e) => {
                                    e.preventDefault();
                                    setTimeout(() => navigate(signoObj.link), 100);
                                }}
                                cursor="pointer"
                            >
                                {/* Imagen del signo */}
                                <image
                                    href={signoObj.img}
                                    x={x - 15}
                                    y={y - 15}
                                    width="30"
                                    height="30"
                                    style={{
                                        transform: hoveredIndex === index ? "scale(1.2)" : "scale(1)",
                                        transformOrigin: `${x}px ${y}px`,
                                        transition: "transform 0.3s ease-in-out",
                                        filter: "invert(1)",
                                    }}
                                />
                                {/* Nombre del signo */}
                                <text x={x} y={y + 35} textAnchor="middle" fontSize="12" fill="#FFD700" dy=".3em">
                                    {signoObj.name}
                                </text>
                            </g>
                        );
                    })}

                    {/* Información del signo en el centro */}
                    {hoveredIndex !== null && (
                        <g>
                            {/* Fondo del tooltip */}
                            <rect
                                x={centerX - 60}
                                y={centerY - 20}
                                width="120"
                                height="60"
                                fill="transparent"
                                stroke="#FFD700"
                                rx="10"
                            />
                            {/* Nombre */}
                            <text x={centerX} y={centerY - 3} textAnchor="middle" fontSize="14" fill="whitesmoke">
                                {signos[hoveredIndex].name}
                            </text>
                            {/* Fechas */}
                            <text x={centerX} y={centerY + 12} textAnchor="middle" fontSize="12" fill="whitesmoke">
                                {signos[hoveredIndex].dates}
                            </text>
                            {/* Elemento */}
                            <text x={centerX} y={centerY + 27} textAnchor="middle" fontSize="12" fill="whitesmoke">
                                {signos[hoveredIndex].element}
                            </text>
                        </g>
                    )}
                </svg>
            </div>
        );
    };

    export default ZodiacWheel;
